import { Navigate, Outlet } from 'react-router';

import { useAuthStore } from '@/store/auth.store';

/** Blocks onboarding/dashboard access until the signed-in user has verified their email. */
export function RequireVerifiedEmailOutlet() {
	const emailIsVerified = useAuthStore((state) => state.user?.emailIsVerified);

	if (!emailIsVerified) {
		return <Navigate to="/verify-email" replace />;
	}

	return <Outlet />;
}
